import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import emlogo from "../../images/em-logo.svg";
import { API_URL } from '../../api/api';

import { toast } from "sonner";
function AddSignature() {
  const navigate = useNavigate();
  // Module is reachable under /admin and /hr — navigate within the same base.
  const basePath =
    (localStorage.getItem("role") || "").toLowerCase().trim() === "hr"
      ? "/hr"
      : "/admin";

  const [formData, setFormData] = useState({
    name: "",
    designation: "",
    phone: "",
    website: "www.electronikmedia.com",
    theme: "white",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  const payload = {
    ...formData,
    phone: `+91 ${formData.phone}`,
  };

  try {
  const token = localStorage.getItem("token");

    await axios.post(`${API_URL}/api/signatures`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    navigate(`${basePath}/signature`, { state: { active: "signatures" } });
  } catch (err) {
    console.error(err);
    toast.error("Error creating signature");
  }
};

  return (
     <>

    {/* Aceternity-style pure-CSS dot background — overlay only, does not
        change the page background colour. Vignette mask fades the dots out
        toward the edges; dot colour is theme-aware (see index.css). */}
    <div className="dot-bg" aria-hidden="true" />
    <div className="edit-form">
      <form onSubmit={handleSubmit} className="edit-signature-form">
        <div className="full-wrap">
          <div className="middle-wrap">
            <div className="signature-wrap lightbox">

              <div className="sig-header">
                <h2>Create Signature</h2>

                <div className="field-item">
                  <div className="label">Choose Theme:</div>
                  <div className="radio-wrap">
                    <label className="light-card">
                      <input
                        type="radio"
                        name="theme"
                        value="white"
                        checked={formData.theme === "white"}
                        onChange={handleChange}
                      />
                      <i></i>
                    </label>

                    <label className="dark-card">
                      <input
                        type="radio"
                        name="theme"
                        value="black"
                        checked={formData.theme === "black"}
                        onChange={handleChange}
                      />
                      <i></i>
                    </label>
                  </div>
                </div>
              </div>

              <div className="signature-box">
                <div className="logo">
              <span className="svg-logo">
                <img src={emlogo}alt="Logo" className="signature-logo"/>
              </span>
              <span className="svg-text">
                {/* Optional inline SVG for text logo */}
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 92.868 7.637">
                  <path id="logo-text" data-name="Union 1" d="M89.264,7.24a1.456,1.456,0,0,1-.456-1.077c0-1.238,1.1-1.915,3.062-1.9V4.157a1.053,1.053,0,0,0-1.156-1.185,2.532,2.532,0,0,0-1.327.38l-.209-.613a3.138,3.138,0,0,1,1.67-.455c1.555,0,1.938,1.067,1.938,2.1V6.3a7.55,7.55,0,0,0,.082,1.226l-.842-.009-.075-.647h-.03a1.891,1.891,0,0,1-1.555.764q-.052,0-.1,0A1.453,1.453,0,0,1,89.264,7.24Zm.467-1.183a.822.822,0,0,0,.871.888,1.265,1.265,0,0,0,1.23-.859,1,1,0,0,0,.051-.3V4.9l-.157,0C90.761,4.9,89.731,5.113,89.731,6.057ZM91.888,4.9Zm-55.1,2.731A2.428,2.428,0,0,1,34.351,5a2.492,2.492,0,0,1,2.524-2.72,2.45,2.45,0,0,1,2.452,2.637,2.5,2.5,0,0,1-2.491,2.72Zm.042-.7c.9,0,1.548-.834,1.548-1.99,0-.868-.43-1.967-1.526-1.967s-1.566,1.016-1.566,1.99h0C35.286,6.087,35.929,6.933,36.834,6.933Zm42.566.7a2.332,2.332,0,0,1-2.175-2.6,2.448,2.448,0,0,1,2.283-2.754,1.7,1.7,0,0,1,1.537.782h.023V0h.923V6.192c0,.455.012.974.041,1.324H81.2l-.04-.888h-.022a1.88,1.88,0,0,1-1.662,1ZM78.168,4.985c0,1.038.5,1.9,1.5,1.9a1.4,1.4,0,0,0,1.357-1.11,1.71,1.71,0,0,0,.041-.4V4.487l0-.011a1.73,1.73,0,0,0-.041-.391,1.364,1.364,0,0,0-1.335-1.08C78.737,3.006,78.168,3.852,78.168,4.985ZM25.261,7.234A1.909,1.909,0,0,1,24.9,5.9v-2.8h-.791V2.4H24.9V1.174l.9-.245V2.393h1.327V3.1H25.8V5.861c0,.636.179,1,.7,1a1.969,1.969,0,0,0,.537-.064l.041.7a2.224,2.224,0,0,1-.819.128l-.077,0A1.282,1.282,0,0,1,25.261,7.234ZM18.542,6.89a2.427,2.427,0,0,1-.678-1.879A2.6,2.6,0,0,1,20.6,2.29a3.13,3.13,0,0,1,1.283.264l-.21.717A2.135,2.135,0,0,0,20.6,3.026a1.932,1.932,0,0,0-.03,3.852,2.655,2.655,0,0,0,1.137-.252l.158.7,0,0a3.368,3.368,0,0,1-1.462.3l-.116,0A2.424,2.424,0,0,1,18.542,6.89ZM71.008,6.9a2.377,2.377,0,0,1-.658-1.865,2.48,2.48,0,0,1,2.389-2.761,2.167,2.167,0,0,1,2.1,2.415,4.334,4.334,0,0,1-.031.433H71.232A1.636,1.636,0,0,0,72.978,6.9a3.358,3.358,0,0,0,1.409-.263l.158.666a4.126,4.126,0,0,1-1.694.316c-.045,0-.091,0-.136,0A2.376,2.376,0,0,1,71.008,6.9Zm.235-2.445h2.7a1.322,1.322,0,0,0-1.282-1.512A1.543,1.543,0,0,0,71.243,4.458ZM11.643,6.9a2.377,2.377,0,0,1-.658-1.865,2.48,2.48,0,0,1,2.389-2.761,2.165,2.165,0,0,1,2.1,2.415,4.334,4.334,0,0,1-.03.433H11.867A1.636,1.636,0,0,0,13.613,6.9a3.363,3.363,0,0,0,1.408-.263l.158.666a4.127,4.127,0,0,1-1.695.316c-.045,0-.091,0-.136,0A2.374,2.374,0,0,1,11.643,6.9Zm.235-2.445h2.7A1.322,1.322,0,0,0,13.3,2.946,1.543,1.543,0,0,0,11.878,4.458ZM.674,6.9A2.377,2.377,0,0,1,.016,5.038,2.48,2.48,0,0,1,2.4,2.277a2.167,2.167,0,0,1,2.1,2.415,4.082,4.082,0,0,1-.031.433H.9A1.636,1.636,0,0,0,2.644,6.9,3.358,3.358,0,0,0,4.053,6.64l.158.666a4.126,4.126,0,0,1-1.694.316c-.045,0-.091,0-.136,0A2.376,2.376,0,0,1,.674,6.9ZM.909,4.458h2.7A1.322,1.322,0,0,0,2.33,2.946,1.544,1.544,0,0,0,.909,4.458ZM60.344,7.52V3.785l-.006,0c0-.53-.011-.963-.041-1.388h.811l.041.824h.031a1.758,1.758,0,0,1,1.6-.94A1.5,1.5,0,0,1,64.218,3.3h.022a2.106,2.106,0,0,1,.568-.666,1.732,1.732,0,0,1,1.125-.361c.673,0,1.671.444,1.671,2.223V7.517h-.9v-2.9c0-.986-.359-1.576-1.1-1.576a1.2,1.2,0,0,0-1.1.846,1.6,1.6,0,0,0-.075.466V7.517h-.9V4.447c0-.816-.359-1.407-1.062-1.407a1.271,1.271,0,0,0-1.148.932,1.332,1.332,0,0,0-.075.455V7.52Zm-3.577,0L55.01,5.061l-.474.53V7.517h-.916V0h.916l0,4.744h.022c.127-.181.307-.4.452-.583l1.5-1.768H57.62L55.653,4.5l2.239,3.017Zm-14.667,0V3.782h0c0-.53-.011-.963-.041-1.388h.819l.052.846h.022a1.874,1.874,0,0,1,1.681-.963c.707,0,1.8.421,1.8,2.182V7.516h-.927V4.563c0-.824-.307-1.512-1.177-1.512A1.313,1.313,0,0,0,43.088,4a1.332,1.332,0,0,0-.064.433V7.517Zm43.036,0V2.392h.927V7.516Zm-35.589,0V2.392h.927V7.516Zm-42.287,0V0h.927V7.516ZM29.775,7.51V3.991c0-.6-.011-1.121-.04-1.6h.811l.03,1h.041A1.528,1.528,0,0,1,32.025,2.27a1.127,1.127,0,0,1,.263.031V3.18a1.281,1.281,0,0,0-1.555,1.166,2.5,2.5,0,0,0-.041.433V7.51ZM85.02.952A.572.572,0,0,1,85.6.369a.556.556,0,0,1,.569.583.574.574,0,1,1-1.147,0Zm-35.588,0a.572.572,0,0,1,.579-.583.556.556,0,0,1,.569.583.574.574,0,1,1-1.147,0ZM81.992,0h0Z" />
                </svg>
              </span>
            </div>


                <div className="sign-details">
                  <h3>
                    <input
                      type="text"
                      name="name"
                      placeholder="Name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </h3>

                  <h4>
                    <input
                      type="text"
                      name="designation"
                      placeholder="Designation"
                      value={formData.designation}
                      onChange={handleChange}
                      required
                    />
                  </h4>

                  <div className="phone add-phone-req">
                   <span className="country-code">+91</span>
                    <i></i>
                    <input
                      type="text"
                      name="phone"
                      placeholder="Phone"
                      value={formData.phone}
                      onChange={(e) => {
      const value = e.target.value.replace(/\D/g, ""); // only numbers
      if (value.length <= 10) {
        setFormData({ ...formData, phone: value });
      }
    }}
                      required
                    />
                  </div>

                  <div className="web">
                    <i></i>
                    <input
                      type="text"
                      name="website"
                      placeholder="Website"
                      value={formData.website}
                      onChange={handleChange}
                      disabled 
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="edit-save">
                <button
                  type="button"
                  className="cancel-btn"
                  onClick={() =>
                    navigate(`${basePath}/signature`, {
                      state: { active: "signatures" },
                    })
                  }
                >
                  Cancel
                </button>
                <button type="submit" className="save-btn">
                  Create
                </button>
              </div>

            </div>
          </div>
        </div>
      </form>
    </div>
     </>
  );
}

export default AddSignature;